import { AxiosResponse } from 'axios';

import { HttpClient } from 'api/HttpClient';

import { CreateRoleRequestDto, RoleDto, UpdateRoleRequestDto } from './roles.dto';

export class RolesApi extends HttpClient {
  public constructor() {
    super(process.env.REACT_APP_API_URL + '/roles');
  }

  public async getAllRoles() {
    return await this.instance.get('/').then((response: AxiosResponse<RoleDto[]>) => response.data);
  }

  public async createRole(role: CreateRoleRequestDto): Promise<RoleDto> {
    return this.instance.post('/', role).then((response: AxiosResponse<RoleDto>) => response.data);
  }

  public async updateRole(id: number, role: UpdateRoleRequestDto): Promise<RoleDto> {
    return this.instance.patch(`/${id}`, role).then((response: AxiosResponse<RoleDto>) => response.data);
  }

  public async deleteRole(id: number): Promise<void> {
    return this.instance.delete(`/${id}`).then(() => {});
  }
}
